import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import AdminLogin from './components/AdminLogin';
import AdminDashboard from './components/AdminDashboard';
import Header from './components/Header';
import Hero from './components/Hero';
import Services from './components/Services';
import Portfolio from './components/Portfolio';
import Team from './components/Team';
import Contact from './components/Contact';
import Footer from './components/Footer';
import AboutAgency from './components/AboutAgency';
import FloatingActions from './components/FloatingActions';
import EcosystemFlow from './components/EcosystemFlow';
import CookieConsent from './components/CookieConsent';

// Componente para la página principal
function HomePage() {
  return (
    <div
      className="
        App min-h-screen overflow-x-hidden font-sans
        bg-slate-200 text-slate-600
        dark:bg-slate-950 dark:text-slate-200
        selection:bg-primary/20 selection:text-secondary
      "
    >
      <Header />

      <main>
        <Hero />
        <EcosystemFlow />
        <AboutAgency />
        <Team />
        <Services />
        <Portfolio />
        <Contact />
      </main>

      <Footer />

      {/* ✅ Botones flotantes globales (WhatsApp + Ir arriba) */}
      <FloatingActions />

      {/* ✅ Banner de cookies al cargar el sitio */}
      <CookieConsent />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          {/* Ruta principal */}
          <Route path="/" element={<HomePage />} />

          {/* Rutas de admin */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <AdminDashboard />
              </ProtectedRoute>
            }
          />

          {/* Redirect para otras rutas */}
          <Route path="*" element={<HomePage />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;